<template>
  <!-- 방문증 분실 신고 안내 -->
  <div>
    <v-card class="ma-4">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold" style="min-width:140px;">
          <v-icon class="mr-2">mdi-monitor-eye</v-icon>방문증 분실 신고 안내
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          방문증 분실 신고는 이렇게 하세요.
        </v-card-subtitle>
      </v-toolbar>
      <v-card-subtitle class="pt-2 pb-2 text-caption grey--text text--darken-2 text-justify font-weight-bold">
          <div class="mb-1 d-flex">1.&nbsp;<div>방문증 분실 시 협력업체 관리자를 통해 즉시 분실 신고를 해야 합니다.(협력업체 관리자만 신고 가능)</div></div>
          <div class="d-flex">2.&nbsp;<div>방문증은 {{$store.state.CustomInfo.SiteNm}}의 소중한 자산으로서 방문증 분실 시 소정의 금액을 청구할 수 있습니다.</div></div>
      </v-card-subtitle>
      <v-divider class="mr-4 ml-4"></v-divider>


      <div class="flex-wrap d-flex justify-center mt-10 mb-4">
        <img src="../assets/SKST/Guide/guide_2_1.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_2_2.svg" style="height:290px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_2_3.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_2_4.svg" style="height:200px; border-radius: 10px;"/>
        <img src="../assets/SKST/Guide/guide_2_5.svg" style="height:200px; border-radius: 10px;"/>
      </div>


      <v-card-text align="center">
        <v-divider class="mb-4"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" width="100" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <v-btn @click="$router.push({name: 'PassReq'});" width="100" dark class="ml-2"><v-icon class="mr-2">mdi-open-in-new</v-icon>신청</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  components: {
  },
  data: () => ({
  }),
  computed: {  
  },
  created() {
  },
  mounted() {
  },

  methods : {
  }
}
</script>